import React, { FC, ReactNode } from 'react';

import AddIcon from '@mui/icons-material/Add';
import Box, { BoxProps } from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';

import EditIcon from '../../assets/icons/Generator/EditIcon';

interface Props extends BoxProps {
  leftIcon?: ReactNode;
  edit?: ReactNode | (() => void);
  create?: ReactNode | (() => void);
}

const Title = styled(Box, {
  shouldForwardProp: prop => prop !== 'hasActions',
})<{ hasActions?: boolean }>(({ theme, hasActions }) => ({
  padding: theme.spacing(1),
  display: 'flex',
  justifyContent: hasActions ? 'space-between' : 'flex-start',
  alignItems: 'center',
}));

const CardTitle: FC<Props> = ({
  children,
  leftIcon,
  edit,
  create,
  ...rest
}) => {
  const renderActionButton = (
    action: ReactNode | (() => void) | null,
    defaultIcon: ReactNode,
  ) => {
    if (!action) return null;

    if (React.isValidElement(action)) return action;

    if (typeof action === 'function') {
      return <IconButton onClick={() => action()}>{defaultIcon}</IconButton>;
    }

    return null;
  };

  return (
    <Title hasActions={Boolean(edit || create)} {...rest}>
      {leftIcon && leftIcon}
      <Typography variant="h4" component="div" sx={{ px: 1, fontWeight: 600 }}>
        {children}
      </Typography>
      {renderActionButton(edit, <EditIcon />)}
      {renderActionButton(create, <AddIcon />)}
    </Title>
  );
};

export default CardTitle;
